import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';
import Loader from '../../components/Loader';

const EmirateForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    name_ar: '',
    code: '',
    status: true
  });

  useEffect(() => {
    if (id) {
      getSingleData();
    }
  }, [id]);

  const getSingleData = async () => {
    try {
      setPageLoader(true);
      const response = await ApiService.request({
        method: 'GET',
        url: `emirates/${id}`,
      });

      const data = response.data;
      if (data.status) {
        setFormData(data.data);
      } else {
        toast.error(data.message);
      }
      setPageLoader(false);
    } catch (error) {
      setPageLoader(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoader(true);

    try {
      const response = await ApiService.request({
        method: 'POST',
        url: `emirates/createOrUpdate${id ? `/${id}` : ''}`,
        data: formData,
      });

      const data = response.data;
      if (data.status) {
        toast.success(data.message);
        navigate('/emirates');
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      setIsLoader(false);
      toast.error('Error saving emirate');
    }
  };

  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              {id ? 'Edit Emirates' : 'Add Emirates'}
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <Link to="/dashboard" className="text-muted text-hover-primary">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">
                <Link to="/emirates" className="text-muted text-hover-primary">Emirates</Link>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">{id ? 'Edit' : 'Add'}</li>
            </ul>
          </div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <form onSubmit={handleSubmit}>
            <div className="card">
              <div className="card-header border-0 pt-6">
                <div className="card-title">
                  <h3 className="fw-bold m-0">Emirates Information</h3>
                </div>
                <div className="card-toolbar">
                  <Link to="/emirates" className="btn btn-light">
                    <i className="ki-duotone ki-arrow-left fs-2"></i>
                    Back
                  </Link>
                </div>
              </div>

              <div className="card-body pt-0">
                {pageLoader ? (
                  <Loader />
                ) : (
                  <div className="row">
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2">Name</label>
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter emirate name"
                        value={formData.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        required
                      />
                    </div>

                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="fs-6 fw-semibold mb-2">Name (Arabic)</label>
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter emirate name in Arabic"
                        value={formData.name_ar}
                        onChange={(e) => setFormData({ ...formData, name_ar: e.target.value })}
                      />
                    </div>

                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2">Code</label>
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter emirate code (e.g., DXB, AUH)"
                        value={formData.code}
                        onChange={(e) => setFormData({ ...formData, code: e.target.value.toUpperCase() })}
                        required
                      />
                    </div>

                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="fs-6 fw-semibold mb-2">Status</label>
                      <select
                        className="form-select form-select-solid"
                        value={formData.status}
                        onChange={(e) => setFormData({ ...formData, status: e.target.value === 'true' })}
                      >
                        <option value={true}>Active</option>
                        <option value={false}>Inactive</option>
                      </select>
                    </div>
                  </div>
                )}
              </div>

              <div className="card-footer d-flex justify-content-end py-6 px-9">
                <Link to="/emirates" className="btn btn-light btn-active-light-primary me-2">
                  Cancel
                </Link>
                <button type="submit" className="btn btn-primary" disabled={isLoader}>
                  {isLoader ? (
                    <>
                      <span className="indicator-progress">Please wait...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    </>
                  ) : (
                    <>
                      <i className="ki-duotone ki-check fs-2"></i>
                      {id ? 'Update Emirates' : 'Save Emirates'}
                    </>
                  )}
                </button>
                
              </div>

            </div>
          </form>
        </div>
      </div>
    </div>
  );

};

export default EmirateForm;
